package com.patronat.top.dto

import kotlinx.serialization.Serializable

@Serializable
enum class UserStatus {
    UNAUTHORIZED,
    ACTIVE,
    DEACTIVATED,
    BLOCKED
}